

export enum GamePartyType {
  duel = 'duel',
  party = 'party'
}